<template>
  <div>
      <el-button type="primary" @click="exportExl" :loading="loading">导出单位详细信息</el-button>
  </div>
</template>



<script>
import {exportApi} from "@/api/module/export/export";

export default {

  name : 'export-class-unit-total-btn',

  data(){
    return {
      sdate : "",
      edate : "",
      data : {},
      loading : false,
      retired : false,
      fresh:false
    }
  },
  methods: {
    setData(date1 ,date2,retired,fresh){
      this.sdate = date1;
      this.edate = date2;
      this.retired = retired;
      this.fresh = fresh;
    },
    
    exportExl(){
      this.loading = true;

      let serverUrl = "/api/manager/export/units";


      let data = {
        "sdate":this.sdate,
        "edate":this.edate,
        "retired":this.retired,
        "fresh":this.fresh
      }


      let filename = "党校微课堂单位详情数据.xls";


      // console.log("exportExl",serverUrl);


      // 暂未提供
      // this.$message.info("功能即将上线");
      // this.loading = false;

      exportApi(data,serverUrl)
          .then((res)=>{
            let data = res.data;
            let url = window.URL.createObjectURL(new Blob([data]));
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click()
          })
          .catch(()=>{
            this.$message.error("错误")
          })
          .finally(()=>{
            this.loading = false;
          })
          ;
    }
  }
  



}


</script>


<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>